<template>
  <div class="auto-renew-policy-form-container">
    <Panel title="7. วิธีชำระเบี้ยประกันปีต่ออายุกรมธรรม์ถัดไป">
      <div class="description-text">
        เลือกความประสงค์ในการต่ออายุอัตโนมัติ
        <span
          class="auto-renew-error-text"
          v-if="applicationValidationErrors.has('isAutoRenewPolicy')"
        >
          * กรุณาเลือกความประสงค์ในการต่ออายุอัตโนมัติ
        </span>
      </div>
      <div class="form-group">
        <div class="input-group">
          <div class="auto-renew-radio-container">
            <Radio
              name="isAutoRenewPolicy"
              :label="true"
              v-model="isAutoRenewPolicy"
              :disabled="isDisabledForm"
            >
              ประสงค์ต่ออายุอัตโนมัติ
            </Radio>
          </div>
          <div class="auto-renew-radio-container">
            <Radio
              name="isAutoRenewPolicy"
              :label="false"
              v-model="isAutoRenewPolicy"
              :disabled="isDisabledForm"
            >
              ไม่ประสงค์ต่ออายุอัตโนมัติ
            </Radio>
          </div>
        </div>
      </div>
    </Panel>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapGetters } from 'vuex'
import { createHelpers } from 'vuex-map-fields'

import Panel from '@/components/Panel'
import Radio from '@/components/Radio'

const { mapFields: mapApplicationFields } = createHelpers({
  getterType: 'getApplicationFields',
  mutationType: 'updateApplicationFields',
})

export default {
  name: 'AutoRenewPolicyForm',
  computed: {
    ...mapApplicationFields({
      isAutoRenewPolicy: 'data.isAutoRenewPolicy',
    }),
    ...mapGetters({
      isDisabledForm: 'isDisabledApplicationForm',
      applicationValidationErrors: 'applicationValidationErrors',
    }),
  },
  components: {
    Panel,
    Radio,
  },
}
</script>

<style lang="scss">
.auto-renew-policy-form-container {
  .description-text {
    margin-bottom: 16px;

    .auto-renew-error-text {
      color: #e40000;
      font-size: 12px;
      line-height: 16px;
    }
  }

  .auto-renew-radio-container {
    display: inline-block;
    margin-right: 32px;
  }
}
</style>
